import { render } from "./CardStats.vue?vue&type=template&id=16c0e82e"
import script from "./CardStats.vue?vue&type=script&lang=js"
export * from "./CardStats.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__